import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import Contact from './pages/Contact/Contact';
import Memberships from './pages/Memberships/Memberships';
import BLXMCourse from './pages/BLXMCourse/BLXMCourse';
import Privacy from './pages/Privacy/Privacy';
import Terms from './pages/Terms/Terms';
import TeamMember from './pages/TeamMember/TeamMember';
import ScrollToTop from './components/ScrollToTop';
import './styles/globals.css';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/memberships" element={<Memberships />} />
            <Route path="/blxm-course" element={<BLXMCourse />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/team/:memberId" element={<TeamMember />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;